export default (valueInPixel: number): string => `${(valueInPixel / 16)}rem`;
